// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-wrapper[data-v-5b6644db] {\n  width: 208px;\n}\n.select-direction[data-v-5b6644db] {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 160px;\n          flex: 0 0 160px;\n}\n.w-fit-content[data-v-5b6644db] {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}", ""]);
// Exports
module.exports = exports;
